'use client'

import dynamic from 'next/dynamic'

// The Storyblok registry is shared by all articles. Keep template code out
// of their entry bundle, while retaining SSR for authored inline popups.
export const PopupInlineLazy = dynamic(() => import('./popup-inline').then((m) => m.PopupInline))
